import { render, staticRenderFns } from "./v-selector.vue?vue&type=template&id=6a6c1fae&scoped=true"
import script from "./v-selector.vue?vue&type=script&lang=js"
export * from "./v-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c1fae",
  null
  
)

export default component.exports